module.exports = __webpack_public_path__ + "img/bigger-logo.cb72e061.png";